import React, { useEffect, useState } from 'react'
import { Wrapper } from './style'
import { ConfigProvider, message, Pagination, Table } from 'antd';
import SpApi from './lib/spApi'
import AmazonAdvertising from './lib/amazonAdvertising'
import { Link, useSearchParams } from 'react-router-dom';
import { MakeApiCall } from '../../../../apis';
import {Helmet} from "react-helmet";

function MarketplaceCredentials({userData}) {
  const [searchParams, setSearchParams] = useSearchParams();

  // Default to spApi if tab is not present in URL
  const tabFromUrl = searchParams.get("tab") || "spApi";
  const [activeTab, setActiveTab] = useState(tabFromUrl);

  const [totalPage, setTotalPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [spApiList, setSpApiList] = useState([]);
  const [advertisingList, setAdvertisingList] = useState([]);

  const fetchUserCredentials = async () => {
    setLoading(true);
    try {
      const response = await MakeApiCall(
          'user-credentials',
          'get',
          null,
          true,
          {},
          userData?.token
      );

      if (response?.status) {
        const records = response?.data?.records || {};
        setTotalPage(response?.data?.pagination?.totalCount || 0);
        setPage(response?.data?.pagination?.page || 1);
        setSpApiList(records['SP-API'] || []);
        setAdvertisingList(records['Advertising-API'] || []);
        return records; // return records so callers (children) can use the fresh data without another API call
      } else {
        message.warning(response?.message);
        setSpApiList([]);
        setAdvertisingList([]);
        return null;
      }
    } catch (error) {
      message.error('Error fetching credentials.');
      setSpApiList([]);
      setAdvertisingList([]);
      return null;
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUserCredentials();
  }, [page, pageSize]);

  useEffect(() => {
    setActiveTab(tabFromUrl);
  }, [tabFromUrl]);

  const handleTabChange = (tabKey) => {
    setActiveTab(tabKey);
    setSearchParams({ tab: tabKey });
  };

  return (
      <Wrapper>
        <Helmet><title>Marketplace credentials</title></Helmet>
        {/* <div class="mb-10 mx-md-n9 mx-n2 px-10 py-5 bg-white filter">
          <div class="position-relative ">
            <ul class="nav nav-tabs nav-line-tabs nav-stretch fs-6 d-inline-flex">
              <li class="nav-item">
                <Link
                    class={`nav-link ${activeTab === 'spApi' ? 'active' : ''}`}
                    onClick={() => handleTabChange('spApi')}
                >
                  Seller Central
                </Link>
              </li>
              <li class="nav-item">
                <Link
                    class={`nav-link ${activeTab === 'advertising' ? 'active' : ''}`}
                    onClick={() => handleTabChange('advertising')}
                >
                  Campaign Manager
                </Link>
              </li>
            </ul>
          </div>
        </div> */}

        {/* {activeTab === 'spApi' && <SpApi list={spApiList} loading={loading} userData={userData} fetchList={fetchUserCredentials}/>} */}
        {/* {activeTab === 'advertising' && <AmazonAdvertising list={advertisingList} loading={loading} userData={userData} fetchList={fetchUserCredentials}/>} */}
        <div className='mt-10'>
          
          <SpApi list={spApiList} loading={loading} userData={userData} fetchList={fetchUserCredentials}/>
          <AmazonAdvertising list={advertisingList} loading={loading} userData={userData} fetchList={fetchUserCredentials}/>
        
        </div>
        
      </Wrapper>
  )
}

export default MarketplaceCredentials